import {ITableColumn} from '../../types';
import {ReactNode} from 'react';

export type UserDimension = { name: string, value: string }

export enum UserStatus {
    UNCONFIRMED = 'UNCONFIRMED',
    CONFIRMED = 'CONFIRMED',
    EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
    RESET_REQUIRED = 'RESET_REQUIRED',
    FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD'
}

export type User = {
    id: string,
    accountId?: string,
    accountAdmin?: string,
    address?: string,
    birthDate?: string,
    email?: string,
    emailVerified?: string
    enabled?: string,
    familyName?: string,
    gender?: string,
    givenName?: string,
    locale?: string,
    middleName?: string,
    name?: string,
    nickname?: string,
    phoneNumber?: string,
    phoneNumberVerified?: string,
    picture?: string,
    profile?: string,
    status: string,
    username?: string,
    website?: string,
    zoneInfo?: string,

    sub?: string,

    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    managedByUsername?: string
    managedBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IUserTableColumn extends ITableColumn {
    render?: (item: User) => ReactNode;
}

export type ListUsers = {
    listUsers: { items: User[] }
}

export type GetUser = {
    getUser: User
}

export type CreateUser = {
    createUser: User
}

export type UpdateUser = {
    updateUser: User
}

export type DeleteUser = {
    deleteUser: string
}

export type UserRecordFormProps = {
    record: User,
    handleSubmit: (values: User) => void
    handleCancel: () => void
}
